const INCIDENT_CLOUD_TABS = {
  AIRDROPPED: 'airdropped',
  TRANSMITTED: 'transmitted',
  UNFINISHED: 'unfinished',
  DELETED: 'deleted',
};

export default INCIDENT_CLOUD_TABS;
